// @flow
import React from 'react'
import { httpPut } from 'lib/http'
import { setBanner, setLoad, setUnload } from 'lib/notification/actions'
import { mapSubaccountToFormValues } from './subaccountUtils'
import styles from '../Main/styles.css'
import MSAForm from './MSAForm'
import IndividualInvestmentForm from './IndividualInvestmentForm'
import HomeForm from './HomeForm'
import LandForm from './LandForm'
import MortgageForm from './MortgageForm'
import VehicleForm from './VehicleForm'

type Props = {
  subaccount: Object,
  accountNumber: string,
  subnumber: string,
  dispatch: Function,
  onSuccess: Function,
  onCancel: Function,
  history?: Object,
}

const SubaccountEditForm = ({ subaccount, accountNumber, subnumber, dispatch, onSuccess, onCancel, history }: Props) => {
  const renderFormByType = () => {
    const type = subaccount?.subaccount_type || ''
    const initialValues = mapSubaccountToFormValues(subaccount)

    const formProps = {
      initialValues,
      onCancel,
      onSubmit: handleSubmit,
      accountNumber,
      subnumber,
      onSuccess,
      subaccount,
    }

    switch (type) {
      case 'home':
        return <HomeForm {...formProps} />

      case 'individual_investment':
        return <IndividualInvestmentForm {...formProps} />

      case 'land':
        return <LandForm {...formProps} />

      case 'mortgage':
        return <MortgageForm {...formProps} />

      case 'msa':
        return <MSAForm {...formProps} />

      case 'vehicle':
        return <VehicleForm {...formProps} />

      default:
        return <div className={styles.formError}>Unknown subaccount type: {type}</div>
    }
  }

  const handleSubmit = (values) => {
    dispatch(setLoad())

    const { balance, ...valuesToSubmit } = values

    const url = `/admin/accounts/${accountNumber}/subaccounts/${subnumber}`

    return httpPut(url, valuesToSubmit)
      .then(() => {
        dispatch(onSuccess)
        dispatch(setBanner('Subaccount successfully updated'))

        if (history) {
          history.push(`/accounts/${accountNumber}/subaccounts/${subnumber}`)
        } else {
          window.location.href = `/accounts/${accountNumber}/subaccounts/${subnumber}`
        }
      })
      .catch((error) => {
        dispatch(setBanner('Failed to update subaccount', 'danger'))
        console.error('Update error:', error)
        return Promise.reject(error)
      })
      .finally(() => {
        dispatch(setUnload())
      })
  }

  return renderFormByType()
}

export default SubaccountEditForm
